import { create } from "zustand"
import { getKpiMetricAPI } from "@/apis/usage-api"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { RESOURCE_KPI_METRICS } from "@/constants/resource-const"

export const kpiMetricStore = create((set) => ({
  kpiMap: { today: RESOURCE_KPI_METRICS },
  carbonMap: { today: {} },
  apiGetKpiMetric: async () => {
    const { sido, kapt_code, ended_at, heat_type } = aptSearchStore.getState().pickApt

    const result = await getKpiMetricAPI({
      sido,
      kapt_code,
      ended_at
    })

    const kpiMap = {}
    const carbonMap = {}

    const FILTERED_METRICS =
      heat_type === 1
        ? RESOURCE_KPI_METRICS.filter((m) => !["hotwater", "hot"].includes(m.key))
        : RESOURCE_KPI_METRICS

    for (const period in result) {
      kpiMap[period] = FILTERED_METRICS.map((m) => ({
        ...m,
        value: result[period].data[m.key].value,
        previous_value: result[period].data[m.key].previous_value,
        unit: result[period].data[m.key].unit,
        diff: result[period].data[m.key].diff,
        is_up: result[period].data[m.key].is_up,
        ...(period === "today" && {
          hourly: result[period].data[m.key].hourly
        })
      }))

      carbonMap[period] = result[period].carbon
    }

    set({ kpiMap, carbonMap })
  }
}))
